// 登录相关
export const IDM_API_KEY = process.env.VUE_APP_IDM_API_KEY;

// new
// 登录相关
export const IDM_URL = process.env.VUE_APP_IDM_API_URL;

// 业务接口相关
export const BASEURL = process.env.VUE_APP_BASEURL;
